/* @flow */

import type { $WidgetEnvConfiguration } from '../types/WidgetEnvConfiguration';
import Endpoints from 'CoreConstants/Endpoints';
import Environments from 'CoreConstants/Environments';
import HereMapsCredentials from 'CoreComponents/MapProviders/HereMaps/HereMapsCredentials';

const config: $WidgetEnvConfiguration = {
  env: Environments.ENV_E2E,
  configurationServiceEndpointInternal: Endpoints.INTERNAL.DSW.CMS.E2E_TESTING,
  configurationServiceEndpointExternal: Endpoints.EXTERNAL.CMS.E2E_TESTING,
  dealerServiceEndpointInternal: Endpoints.INTERNAL.DSW.DMS.E2E_TESTING,
  dealerServiceEndpointExternal: Endpoints.EXTERNAL.DMS.E2E_TESTING,
  mapProviders: {
    hereMaps: {
      appId: HereMapsCredentials.DEV_APP_ID,
      appCode: HereMapsCredentials.DEV_APP_CODE,
      useCIT: true
    }
  }
};

export default config;
